import {EventEmitter, Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {take, takeUntil} from 'rxjs/operators';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {Subject} from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {ShareItemService} from '@shared/services/share-item.service';
import {FileManagerService} from '@features/file-manager/services/file-manager.service';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';
import {IconViewModel} from '@features/file-manager/models/file-manager.model';
import {Page} from '@shared/models/pdf-form-viewer/pdf-form-metadata.model';
import {PdfParserService} from '@shared/services/pdf-parser.service';
import {FieldDefinition} from '@shared/models/field-definition';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {VirtualGridSelectionService} from '@core/services/virtual-grid-selection.service';
import {SetActivityFeedAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {ItpDesktopService} from '@core/services/itpdesktopservices/itp-desktop.service';
import {Configuration} from '@shared/models/configuration';
import {FileDialogComponent} from '@features/file-manager/component/file-dialog/file-dialog.component';
import {DownloadFileCommand} from '@features/file-manager/commands/create-directory.command';
import {MatDialog} from '@angular/material/dialog';
import {Api} from '@shared/constants/common-field.constants';


@Injectable({
  providedIn: 'root',
})
export class PlatformToolFillablePdfHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  ngUnsubscribe = new Subject<void>();
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  invalidateSubject: InvalidateSubject;

  private selectedTabModel: TabModel;
  isDesktop: string;
  ngUnsubscribe$ = new Subject<void>();

  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              protected store: Store<IQueryState>,
              private snackBarService: SnackBarService,
              protected fileManagementService: FileManagementService,
              protected pdfParserService: PdfParserService,
              private dialog: MatDialog,
              protected fileManagerService: FileManagerService,
              protected shareItemService: ShareItemService,
              private fileStoreCommonService: FileStoreCommonService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private itpDesktopService: ItpDesktopService,
              private virtualGridSelectionService: VirtualGridSelectionService) {
    this.invalidateSubject = new InvalidateSubject();
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    if (!command.api) {
      const downloadUrl = command.fieldValues['DownloadUrl'];
      if (downloadUrl) {
        this.fileManagementService.downloadOneTimeSignedUrl(downloadUrl, command.fieldValues['FileName']);
      }
    } else if (command.api && command.api.length > 0 && !command.isDisabled) {
      switch (command.name) {
        case 'ConfigureFieldsCommand':
          const message = `Configuring fields might affect existing responses.`;
          const question = `Are you sure you want to configure fields?`;
          this.dialogService.showConfirmDialog('Warning', 'Yes', 'Cancel', message, question).subscribe(dialogState => {
            if (dialogState.action === 'OK') {
              command.name = 'OpenFileCommand';
              this.executeCommandToApi(command, callBack);
            }
          });
          break;
        case 'ExternalPlatformCommand':
          this.handleExternalPlatformCommand(command,callBack);
          break;
/*        case 'ConvertToFillablePdfCommand':
          this.convertToFillablePdfCommand(command);
          break;*/
/*        case 'ImportFillablePdfResponseDataCommand':
          this.importFillablePdfResonseData(command);
          break;*/
        case 'ToggleViewModesForFillablePdfCommand':
          this.ToggleViewModesForFillablePdfCommand(command);
          break;
        case 'DownloadPdfFileWithResponseCommand':
        case 'CreateQuestionsForFillablePdfCommand':
          this.fuseSplashScreenService.show();
          this.executeCommandToApi(command, callBack);
          break;
        case 'AutoGenerateQuestionsFromFillablePdfCommand':
          this.magicLinkModelValueChangedHandler({name: command.name, command: command});
          break;
        default:
          this.executeCommandToApi(command, callBack);
          break;
      }
    }
  }

  executeCommandWithHandler(command: PlatformCommand, callBack?: any) {
    console.log('Executing PlatformCommand : ', command.name);
    if (command.fieldValues['CommandHandler']) {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this);
        return;
      }
    }
    this.executeCommand(command, this);
  }

  selectionChanged($event: any) {
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if ($event.action) {
      this.handleAction($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'ResponseId' && this.magicLinkModel.additionalCommands['ShowResponse']) {
      const showResponseCommand = this.magicLinkModel.additionalCommands['ShowResponse'];
      showResponseCommand.fieldValues['DataItemId'] = $event.item.id;
      this.executeCommandWithHandler(showResponseCommand);
      return;
    }
    if ($event.name) {
      this.handleEventsByName($event);
      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'Header') {
      this.navigateToField($event);
      return;
    }
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setSelectedTab(selectedTab: TabModel): void {

  }

  private handleAction($event: GridValueChangeEvent) {
    if ($event.item && $event.item.type === 'QuestionnaireResponse') {
      this.questionnaireResponseAction($event);
      return;
    }
    if (this.handleDriveActions($event)) {
      return;
    } else {
      const command = this.magicLinkModel.additionalCommands[$event.action.id];
      if (command) {
        const project = $event.item.cells['Name'].value;
        command.fieldValues['DriveId'] = $event.item.id;
        if ($event.action.id === 'ToggleStarContent') {
          command.fieldValues['IsFavorite'] = $event.item.cells['IsFavorite']?.value;
          command.fieldValues['ItemId'] = $event.item.id;
          command.fieldValues['Type'] = $event.item.cells['Type']?.value;
        }
        this.executeCommandWithHandler(command);
        return;
      }
    }
  }

  private questionnaireResponseAction($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Show Activity':
        let referenceCode = $event.item.cells['ReferenceCode']?.value;
        let referenceName = $event.item.cells['ReferenceName']?.value;
        if (referenceCode == null) {
          referenceCode = $event.item.id;
          referenceName = $event.item.cells.ResponseId?.displayText;
        }
        const activityInfo = {type: 'ReferenceCode', 'id': referenceCode, 'title': referenceName, isDefault: false};
        this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
        break;
      case 'Edit':
        this.openEditor($event);
        break;
      default:
        if ($event.action.id === 'Delete' && $event.fieldDefinition.dataType === 'Attachment') {
          this.removeQuestionnaireAttachment($event);
        } else if (this.magicLinkModel.additionalCommands[$event.action.id]) {
          const showResponseCommand = this.magicLinkModel.additionalCommands[$event.action.id];
          showResponseCommand.fieldValues['DataItemId'] = $event.item.id;
          if ($event.fieldDefinition) {
            showResponseCommand.fieldValues['FieldKey'] = $event.fieldDefinition.key;
            showResponseCommand.fieldValues['FieldHeader'] = $event.fieldDefinition.header;
          }
          this.executeCommandWithHandler(showResponseCommand);
        }

    }
  }

  private removeQuestionnaireAttachment($event: GridValueChangeEvent) {
    if (this.magicLinkModel.additionalCommands[$event.action.id]) {
      const command = this.magicLinkModel.additionalCommands['UpdateFlowchartItemCommand'];
      command.fieldValues['ItemId'] = $event.item.id;
      command.fieldValues['FieldKey'] = $event.fieldDefinition.key;
      command.fieldValues[$event.fieldDefinition.key] = null;
      this.fileStoreCommonService.executeCommand(command).pipe().subscribe(commandState => {
        console.log(commandState);
        this.invalidateSubject.invalidate();
      });
    }
  }

  private handleDriveActions($event: GridValueChangeEvent): boolean {
    if ($event.action) {
      switch ($event.action.id) {
        case 'DeleteMultiple':
          this.deleteItems($event);
          return true;
        case 'DeleteForever':
          this.fileStoreCommonService.openDeleteFileOrFolderConfirmationDialog([{
            itemId: $event.item.id,
            type: $event.item.cells && $event.item.cells['IsFolder'] ? 'Folder' : ''
          }], true);
          break;
        case 'Edit':
          return this.editGridCellValue($event);
          return true;
        case 'Navigate to Field':
          this.navigateToField($event);
          return true;
        case 'UpdatePlatformToolContainer':
          this.magicLinkModelValueChangedHandler({id: 'PlatformToolContainerComponent', value: $event.platformLink});
          return true;
        default:
          return true;
      }
    }
    return false;
  }


  private extractFillablePdf(command: PlatformCommand) {
    if (command.fieldValues != null) {
      const isClientFile = command.fieldValues['IsClientDrive'];
      const fileId = command.fieldValues['FileId'];
      this.fuseSplashScreenService.show();
      if (!isClientFile) {
        this.fileManagementService.downloadFileWithContentId(fileId).pipe(take(1)).subscribe(file => {
          this.parsePdf(file, command);
        }, err => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('File download failed!');
        });
      } else {
        this.fileManagementService.downloadClientFileWithContentId(fileId).pipe(take(1)).subscribe(file => {
          this.parsePdf(file, command);
        }, err => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('File download failed!');
        });
      }
    }
  }

  private parsePdf(file: Blob, command: PlatformCommand) {
    //const userFormMetaData: Array<Page> = [];
    this.fuseSplashScreenService.show();
    this.executeCommandToApi(command);
/*    this.pdfParserService.extractMetadata(file).pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      userFormMetaData.push(data.metadataByPage);
      if (userFormMetaData.length === data.totalPage) {
        command.fieldValues['PdfFormMetaData'] = userFormMetaData;
        this.executeCommandToApi(command);
      }
    });*/
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  private executeCommandToApi(command: PlatformCommand, callBack?: any) {
    const observer = this.commandService.executePlatformCommand(command);
    if (observer) {
      this.fuseSplashScreenService.show();
      observer.pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          const downloadUrl = commandResponse.fieldValues['DownloadUrl'];
          if (downloadUrl) {
            this.fileManagementService.downloadOneTimeSignedUrl(downloadUrl, commandResponse.fieldValues['FileName']);
          } else {
            if (commandResponse.fieldValues['RedirectCommand']) {
              this.executeCommandWithHandler(commandResponse.fieldValues['RedirectCommand'], callBack);
              return;
            }
            if (commandResponse.fieldValues['RedirectUrl']) {
              this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
              return;
            }
            if (commandResponse.fieldValues['RedirectToExternalUrl']) {
              console.log(`RedirectToExternalUrl : ${commandResponse.fieldValues['RedirectToExternalUrl']}`);
              window.open(commandResponse.fieldValues['RedirectToExternalUrl']);
            }
            if (commandResponse.fieldValues['PlatformLinkModel']) {
              this.magicLinkModelValueChangedHandler({
                id: 'PlatformToolContainerComponent',
                value: commandResponse.fieldValues['PlatformLinkModel']
              });
              return;
            }
            if (commandResponse.fieldValues['SnackBarMessage']) {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
              this.invalidateSubject.invalidate('OrbitaxDrive');
              if (commandResponse.fieldValues['Reload'] && commandResponse.fieldValues['Reload'] === true) {
                this.invalidateSubject.invalidate();
              }
              return;
            }
            this.invalidateSubject.invalidate('Refresh');
          }
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private editGridCellValue(event: any) {
    // currently working for fillable pdf for demo. need to make generic
    const fillablePdfFieldDefinitionId = this.magicLinkModel.tabBar.tabs[0].tabData['FillablePdfFileDefinitionId'];
    if (fillablePdfFieldDefinitionId) {
      this.editFillablePdfgridValue(event.item, event.fieldDefinition);
      return true;
    }
  }


  private openEditor(event: any) {
    let sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    if (this.magicLinkModel.tabBar.tabs[0].tabData['ReplacementSourceKey']) {
      sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['ReplacementSourceKey'];
    }
    const minWidth = '800px';
    const maxWidth = '1500px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth,
      sourceType).subscribe(state => {
      if (state.action === 'OK') {
        const value = event.item.cells[event.fieldDefinition.key].value;
        const command = this.magicLinkModel.additionalCommands['UpdateFlowchartItemCommand'];
        command.fieldValues['ItemId'] = event.item.id;
        command.fieldValues['FieldKey'] = event.fieldDefinition.key;
        command.fieldValues[event.fieldDefinition.key] = value;
        this.fileStoreCommonService.executeCommand(command).pipe().subscribe(commandState => {
          console.log(commandState);
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  private editFillablePdfgridValue(item: any, fieldDefinition: FieldDefinition) {
    const minWidth = '600px';
    const maxWidth = '600px';
    const sourceKey = this.magicLinkModel.tabBar.tabs[0].tabData['DirectoryEntryId'];
    this.dialogService.showCellEditorDialog(item, fieldDefinition, minWidth, maxWidth,
      sourceKey, undefined, {disableFieldSettings: true}).pipe(take(1)).subscribe(state => {
      if (state.action === 'OK') {
        this.submitFieldValue(fieldDefinition.key, item.cells[fieldDefinition.key].value, item.id);
      }
    });
  }

  private submitFieldValue(fieldKey: string, value: any, itemId: string) {
    this.fuseSplashScreenService.show();
    const command = this.magicLinkModel.additionalCommands['UpdateFlowchartItemCommand'];
    command.fieldValues['ItemId'] = itemId;
    command.fieldValues['FieldKey'] = fieldKey;
    command.fieldValues[fieldKey] = value;
    command.fieldValues['IncludeDefaultFieldKeysInRowItem'] = false;
    command.fieldValues['FillablePdfFileDefinitionId'] = this.magicLinkModel.tabBar.tabs[0].tabData['FillablePdfFileDefinitionId'];
    command.isCamelCase = true;
    command.waitForResponse = true;
    this.fuseSplashScreenService.show();
    this.executeCommandToApi(command);
  }


  private navigateToField($event: GridValueChangeEvent) {
    this.magicLinkModelValueChangedHandler({
      name: 'NavigateToField',
      value: $event
    });
  }

  deleteItems($event: GridValueChangeEvent) {
    const selectedItems = this.virtualGridSelectionService.virtualGridSelection('ClientDirectoryEntry');
    const items: IconViewModel[] = [];
    selectedItems.itemSelections.forEach(o => {
      items.push(this.fileStoreCommonService.getIconViewModel(o));
    });
    this.fileStoreCommonService.openDeleteFileOrFolderConfirmationDialog(items);
  }

  private handleEventsByName($event: any) {
    switch ($event.name) {
      case 'CardViewCheckboxSelectionChanges':
        this.magicLinkModelValueChangedHandler({
          name: $event.name,
          value: $event
        });
        break;
      case 'CardViewFieldDefinitionUpdateChanges':
        this.magicLinkModelValueChangedHandler({
          name: $event.name,
          value: $event
        });
        break;
    }
  }

  private ToggleViewModesForFillablePdfCommand(command: PlatformCommand) {
    let flowchartId = command.fieldValues['FlowchartId'];
    if(flowchartId) {
      this.fuseSplashScreenService.show();
      let api = command.api;
      let isClientDrive = command.fieldValues['IsClientDrive'];
      let checkCommand = new PlatformCommand('FillablePdfConfigureFieldsCheckCommand', api);
      checkCommand.fieldValues['FlowchartId'] = flowchartId;
      checkCommand.fieldValues['IsClientDrive'] = isClientDrive;
      this.commandService.executePlatformCommand(checkCommand).pipe(take(1)).subscribe(response => {
        this.fuseSplashScreenService.hide();
        if(response && response.fieldValues && response.fieldValues['HasResponse']) {
          const message = `The pdf has already some responses. Reconfiguring fields might impact the existing responses.`;
          const question = `Are you sure to configure files?`;
          this.dialogService.showConfirmDialog('Configure Fields', 'Yes', 'Cancel', message, question).subscribe(dialogState => {
            if (dialogState.action === 'OK') {
              this.fuseSplashScreenService.show();
              this.executeCommandToApi(command);
            }
          });
        } else {
          this.fuseSplashScreenService.show();
          this.executeCommandToApi(command);
        }
      }, err => {
        this.fuseSplashScreenService.hide();
        console.log('err => ', err);
      });
    } else {
      this.fuseSplashScreenService.show();
      this.executeCommandToApi(command);
    }
  }

  private getFileStoreDataItembyFlowchartId(api: string, flowchartId: any, isClientDrive: boolean) {
    const url = `${Configuration.getConfig(api)}FillablePdf/GetFileStoreDataItembyFlowchartId?flowchartId=${flowchartId}&isClientDrive=${isClientDrive}`;
    return url;
  }

  private convertToFillablePdfCommand(command: PlatformCommand) {
    let isClientDrive = command.fieldValues['IsClientDrive'];
    let checkCommand = new PlatformCommand('FillablePdfConfigureFieldsCheckCommand', Api.FileStoreApi);
    checkCommand.fieldValues['IsClientDrive'] = isClientDrive;
    this.commandService.executePlatformCommand(checkCommand).pipe(take(1)).subscribe(response => {
      this.extractFillablePdf(command);
    }, err => {
      console.log('err => ', err);
    });
  }

  private importFillablePdfResonseData(command: PlatformCommand) {
    const dialogRef = this.dialog.open(FileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data    : {
        itemsUrlIndex : 1,
        type          : 'SharedDrives',
        folderId      : '',
        driveId       : '',
        isFileSelector: true,
        hideOverwriteOption: true
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.ngUnsubscribe)).subscribe((result: any) => {
      if (result) {
        this.fuseSplashScreenService.show();
        this.fileManagementService.downloadClientFileWithId(result.id).pipe(take(1)).subscribe(file => {
          this.parsePdf(file, command);
        }, err => {
          this.fuseSplashScreenService.hide();
          this.snackBarService.showError('File download failed!');
        });
      }
    });
  }

  private handleExternalPlatformCommand(command: PlatformCommand, callBack?: any) {
    let externalCommandName = '';
    if (command.fieldValues && command.fieldValues.hasOwnProperty('ExternalCommandName')) {
      externalCommandName = command.fieldValues['ExternalCommandName'];
    }
    switch (externalCommandName) {
      case 'ConvertToFillablePdfCommand':
        this.convertToFillablePdfCommand(command);
        break;
      default:
        this.executeCommandToApi(command, callBack);
        break;
    }
  }
}
